export var normalizer = (function () {
  var from = "ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç",
    to = "AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc",
    mapping: any = {};

  for (var i = 0, j = from.length; i < j; i++)
    mapping[from.charAt(i)] = to.charAt(i);

  return function (str: string) {
    var ret = [];
    for (var i = 0, j = str.length; i < j; i++) {
      var c = str.charAt(i);
      if (mapping.hasOwnProperty(str.charAt(i))) ret.push(mapping[c]);
      else ret.push(c);
    }
    return ret.join("");
  };
})();

function normalizeText(text: string): string {
  return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export const searchInvestigators = (
  investigators: any[],
  searchText: string
) => {
  let filteredInvestigators: any[] = [];
  investigators.forEach((investigator: any) => {
    if (
      normalizeText(investigator?.name.toLowerCase()).includes(
        normalizeText(searchText.toLowerCase())
      ) ||
      normalizeText(investigator?.surname1.toLowerCase()).includes(
        normalizeText(searchText.toLowerCase())
      ) ||
      normalizeText(investigator?.surname2?.toLowerCase())?.includes(
        normalizeText(searchText?.toLowerCase())
      )
    ) {
      filteredInvestigators.push(investigator);
    }
  });

  return filteredInvestigators;
};